import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "jni-ios-app",
  templateUrl: "./ios-app.component.html",
  styleUrls: ["./ios-app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class IosAppComponent {
  constructor(private router: Router) {}

  backNavigation() {
    this.router.navigate(["sale-mobile-app"]);
  }
}
